// Shared copy for "are you sure you want to downgrade" confirmations.
// Used by both DowngradeModal (the dedicated downgrade-targets modal) and
// UpgradeModal (whose plan grid can also point at a cheaper plan — a
// Growth→Pay-as-you-go click there is a downgrade too, and must read and
// behave exactly the same way). Keeping this in one place means the two
// modals can never drift apart on what a downgrade actually costs the user.
export function downgradeConfirmationCopy({
  currentStatus,
  currentPlanName = "your current plan",
  currentPeriodEnd,
  targetPlan,
}) {
  const periodEndText = currentPeriodEnd
    ? new Date(currentPeriodEnd).toLocaleDateString()
    : "the end of the current billing period";

  const body = currentStatus === "past_due"
    ? `Your ${currentPlanName} renewal wasn't paid. Switching to ${targetPlan.name} happens right away: the unpaid invoice is cancelled, you won't be charged, and ${currentPlanName} credits are removed. Add-on credits stay.`
    : `${currentPlanName} stays active until ${periodEndText}. On that date you move to ${targetPlan.name}.${
        targetPlan.code === "pay_as_you_go" ? " You won't be charged a monthly fee after that." : ""
      }`;

  return { title: `Switch to ${targetPlan.name}?`, body };
}
